export const services = [
  {
    id: 1,
    name: "Protecting Your Car from Rust: Prevention Tips for Every Season",
    img: "https://d2m3nfprmhqjvd.cloudfront.net/blog/20220228140012/ezgif.com-gif-maker-23.jpg",
    link: "https://www.shelterlogic.com/media/magefan_blog/H1-how-to-prevent-car-rust.jpg",
    description:
      "Rust can be a car owner's worst enemy. This blog post outlines effective strategies for preventing rust formation, offering tips for every season. From applying rust inhibitors to addressing paint chips promptly, car owners will learn how to keep their vehicles looking great and structurally sound.",
  },
  {
    id: 2,
    name: "The Importance of Regular Car Maintenance: A Comprehensive Guide",
    img: "https://scontent.fabv2-2.fna.fbcdn.net/v/t39.30808-6/340080385_442318504769475_1247355354882313100_n.jpg?_nc_cat=109&ccb=1-7&_nc_sid=c83dfd&_nc_ohc=0oEAYitWKMwAX9S3rEF&_nc_zt=23&_nc_ht=scontent.fabv2-2.fna&oh=00_AfAKsssCpiUrN0wcNWaYqhzuiBqul2wy59oGdExPAYecOA&oe=657EDFF4",
    link: "https://consumerauto.us/blog/regular-car-maintenance/",
    description:
      "In today’s fast-paced world, owning a car has become a necessity, making it crucial to ensure that your vehicle remains in optimal condition. Regular car maintenance is the cornerstone of ensuring your car’s longevity, performance, and safety. Neglecting routine maintenance can lead to costly repairs and compromise your safety on the road. In this comprehensive guide, we will delve into the various aspects of regular car maintenance that every car owner should prioritize.",
  },
];
